module.exports = __webpack_public_path__ + "static/media/RecomendaDiaTrabalhador.07f27456.jpg";